/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 11/10/2021
 */

//incomplete, incomplete_expired, trialing, active, past_due, canceled, or unpaid
export default Object.freeze({
	NOT_SET: "not_set",
	ACTIVE: "active",
	PAST_DUE: "past_due",
	INCOMPLETE: "incomplete",
	INCOMPLETE_EXPIRED: "incomplete_expired",
	TRIALING: "trialing",
	FREE: "free",
	CANCELED: "canceled",
	UNPAID: "unpaid",
	PAUSED: "paused",//	Indicates that this subscription has been paused. We treat this user as ‘cancelled’ unless they re-subscribe.

})
